import { render, staticRenderFns } from "./CommissionRatioField.vue?vue&type=template&id=523b245a"
import script from "./CommissionRatioField.vue?vue&type=script&lang=ts"
export * from "./CommissionRatioField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports